var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { classNames } from '../../utils/cn';
var cls = classNames('markdown-embed');
import React from 'react';
import { useEmbeds } from '../../hooks/use-embeds';
import { find } from 'lodash';
export var MarkdownEmbed = function MarkdownEmbed(props) {
  var className = props.className,
      id = props.id,
      slug = props.slug,
      fieldName = props.fieldName,
      children = props.children,
      attr = props.attr;
  var embeds = useEmbeds();
  var additionalProps = attr && attr(props);
  var entityEmbeds = embeds[fieldName] || [];
  var entity = find(entityEmbeds, function (embed) {
    return embed.slug && embed.slug === id || embed.slug && embed.slug === slug || embed.id && embed.id === id;
  });

  if (!entity) {
    return null;
  }

  var Component = props.component;
  return React.createElement(Component, __assign({
    entity: entity,
    className: cls.name(className)
  }, additionalProps), children);
};